import React, { useEffect, useState } from "react";
import { Loader } from "../../loader";
import { useForm } from "react-hook-form";
import { fetchAPI } from "../../service/Encrtyption";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Gift from "../../../assets/images/gift.png";
import CashReward from "../../../assets/images/cashReward.png";
import GiftReward from "../../../assets/images/giftReward.png";
import SuccessIcon from "../../../assets/images/successIcon.png";
import DelegateBottle from "../../../assets/images/delegateBottle.svg";
import CustomModal from "../../modal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useParamarshDetails } from "../../../utils";
import { formControlClasses } from "@mui/material";
import Accordion from "react-bootstrap/Accordion";
import { rewardMoney } from "../../auth/redux/store";
import ReactGA from 'react-ga4';
import Header from "../../layout/Header";


export const UpiDetails = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { lang } = useParams();
  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
  } = useForm();
  const [loading, setLoading] = useState(false);
  const genunityData = useSelector((state) => state.genunityData);
  const myRewardsData = useSelector((state) => state.myRewardsData);
  const user = useSelector((state) => state.user);
  const claimValue = useSelector((state) => state.claimValue);
  const [rewardUpdateModal, setRewardUpdateModal] = useState(false);
  const [responseModal, setResponseModal] = useState({
    show: false,
    message: "",
    status: "",
  });
  const [succeMessage, setsucceMessage] = useState("");
  const [errroMsg, setErrorMsg] = useState("");

  // const mobileNumber = user?.mobileNumber;
  const mobileNumber = sessionStorage.getItem('mbn');
  const serverRecordId = genunityData?.serverRecordId;
  const dispatch = useDispatch();
  const reclaimDataObj = useSelector((state) => state.reclaimDataObj);
  const amount = useSelector((state) => state.amount);

  console.log(amount + "amount");

  const [fetchData, rewardsData, reclaimRewards, reclaimData, cashRewardsData, loader] = useParamarshDetails();

  // console.log("rewardsData--------"+JSON.stringify(rewardsData))
  // console.log("cashRewardsData--------"+JSON.stringify(cashRewardsData))  

  const location = useLocation();
  const clickedType = location.state?.type;
  // console.log(clickedType); 

  const [upiValue, setUpiValue] = useState(clickedType?.toLowerCase() === "upilinkedmobno" ? mobileNumber : "");
  const beneficiaryName = sessionStorage.getItem("name") || "";

  const [formData, setFormData] = useState({
    cashFreeTransactionId: 0,
    cashRewards: "",
    claimIDs: [],
    dsrProgramId: 0,
    ecouponFarmerMapId: 0,
    paymentMode: clickedType,
    phoneNumber: upiValue,
    seadProgramId: 0,
    upiVpa: upiValue,
    accountName: beneficiaryName,
    destinationURL: "/cashFreeReward/cashFreePaymentModeRequest_V2",
  });

  useEffect(() => {
    // debugger;
    if (!claimValue) {
      // If claimValue is falsy (null, undefined, false, etc.), update formData
      setFormData((prevData) => ({
        ...prevData,
        cashFreeTransactionId: reclaimDataObj.cashFreeTransactionId,
        cashRewards: reclaimDataObj.amount,
        claimIDs: [],
      }));
    } else {
      // If claimValue is truthy, fetch data (assuming fetchData is defined);
      fetchData();
    }
  }, [claimValue, reclaimDataObj]);

  const handleChange = (fieldName, value) => {
    // debugger;
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
      phoneNumber: fieldName === "upiVpa" ? value : prevData.phoneNumber,
      cashRewards: claimValue ? cashRewardsData : amount,
      mobileNumber: mobileNumber,
      claimIDs: claimValue ? rewardsData : []
    }));
    // console.log("setdata"+JSON.stringify(formData));
  };

  console.log("formData+--------------" + JSON.stringify(formData));

  const onSubmit = async () => {
    // debugger;
    setLoading(true);

    ReactGA.event({
      category: 'User UPI Details',
      label: 'Claim UPI Details',
      action: 'Claim UPI Details Clicked'
    });

    console.log("formData on submit" + JSON.stringify(formData));

    if (!formData.cashRewards || !formData.upiVpa || (formData.claimIDs && formData.claimIDs.length == 0)) {
      setErrorMsg(t("sessionExpired"));
      setTimeout(() => {
        navigate(`/${lang}/home`);
      }, 2000);
      return;
    }

    try {
      // debugger;
      const responseData = await fetchAPI(process.env.REACT_APP_API_URL, formData, {
        mobileNumber: mobileNumber, 
        appLangCode: lang
      });
      //  debugger; 
      console.log("upiformdatasubmit" + JSON.stringify(formData));
      const jsonReposneData = JSON.parse(responseData);
      console.log(JSON.stringify(jsonReposneData) + "Upi claim res data");
      const responseStatus = String(jsonReposneData?.status ?? jsonReposneData?.subCode ?? jsonReposneData?.statusCode ?? "");
      if (jsonReposneData?.statusCode === "200" && responseStatus === "200") {
        navigate(`/${lang}/transferSucces`);
      } else {
        setResponseModal({
          show: true,
          message: jsonReposneData?.secondaryMsg || jsonReposneData?.message || "",
          status: responseStatus,
        });
        if (responseStatus === "201") {
          setTimeout(() => navigate(`/${lang}/home`), 2000);
        }
      }

    } catch (error) {
      console.error("Error fetching API:", error);
    } finally {
      setLoading(false);
    }
  };

  const closeResponseModal = () => {
    setResponseModal((prevModal) => ({ ...prevModal, show: false }));
  };

  return (
    <>
      <Header />
      <div className="main">
        <div className="container p-0">
          {loading && <Loader />}
          {loader && <Loader />}
          <div className="card border-0">
            <Accordion.Header id="transfer">
              <div>
                <i className="fa fa-chevron-left text-white mr-2"
                  onClick={() => {
                    ReactGA.event({
                      category: 'btn',
                      action: 'UPI details to Home Clicked',
                      label: 'UPI Details To Home Btn'
                    });
                    navigate(`/${lang}/home`)
                  }}
                ></i>
                {t("transfer")}
              </div>
              <span className="float-end">
                <span>₹{amount}</span>
              </span>
            </Accordion.Header>
            <div className="card-body px-2 pt-0 pb-2">
              <div className="px-4 py-2 mt-3">
                <i className="fa fa-arrow-left mr-2" onClick={() => {
                  ReactGA.event({
                    category: 'btn',
                    action: 'UPI details to Payment Mode Clicked',
                    label: 'UPI Details To Payment Mode Btn'
                  });
                  navigate(`/${lang}/paymentmode`)
                }

                }></i>
                <span className="infoText mb-0"> {clickedType === "upiLinkedMobNo" ? t("UPILinkedMobileNumber") : t("UPI")}</span>
                <hr className="mt-2" />

                <div className="mt-5">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div>
                      {/* <input
                        type="text"
                        autoComplete="off"
                        className={`form-control bankInput mb-2 ${errors.upiVpa ? "is-invalid" : ""
                          }`}
                        placeholder="UPI VPA"
                        name="upiVpa"
                        id="upiVpa"
                        {...register("upiVpa", {
                          required: t("UPIErrorMsg"),
                        })}
                        onChange={(e) => handleChange("upiVpa", e.target.value)}
                      // onKeyUp={(e) => handleChange("upiVpa", e.target.value)}
                      /> */}

                      <input
                        type="tel"
                        autoComplete="off"
                        className={`form-control bankInput mb-2 ${errors.upiVpa ? "is-invalid" : ""
                          }`}
                        placeholder={
                          clickedType === "upiLinkedMobNo"
                            ? t("UPILinkedMobileNumber")
                            : "UPI VPA"
                        }
                        name="upiVpa"
                        id="upiVpa"
                        maxLength={clickedType === "upiLinkedMobNo" ? 10 : undefined}
                        {...register("upiVpa", {
                          required: t("UPIErrorMsg"),
                          validate: (value) => {
                            if (clickedType === "upiLinkedMobNo") {
                              return (
                                /^[6-9]\d{9}$/.test(value) ||
                                t("UPIErrorMsg")
                              );
                            }
                            return true;
                          },
                        })}
                        onChange={(e) => {
                          let value = e.target.value;

                          if (clickedType === "upiLinkedMobNo") {
                            // Allow only digits
                            value = value.replace(/\D/g, "");

                            // First digit must be 6-9
                            if (value.length > 0 && !/^[6-9]/.test(value)) {
                              value = value.substring(1);
                            }

                            // Maximum 10 digits
                            value = value.slice(0, 10);
                          }

                          e.target.value = value;

                          setUpiValue(value);
                          handleChange("upiVpa", value);
                        }}
                        onKeyDown={(e) => {
                          if (clickedType === "upiLinkedMobNo") {
                            const allowedKeys = [
                              "Backspace",
                              "Delete",
                              "ArrowLeft",
                              "ArrowRight",
                              "Tab",
                            ];

                            if (allowedKeys.includes(e.key)) return;

                            // Allow only digits
                            if (!/^\d$/.test(e.key)) {
                              e.preventDefault();
                              return;
                            }

                            // Prevent first digit 0-5
                            if (
                              e.currentTarget.selectionStart === 0 &&
                              e.currentTarget.value.length === 0 &&
                              /^[0-5]$/.test(e.key)
                            ) {
                              e.preventDefault();
                            }
                          }
                        }}
                      />

                      {errors.upiVpa && (
                        <div className="invalid-feedback">
                          {errors.upiVpa.message}
                        </div>
                      )}

                      {errroMsg && (
                        <>
                          <div
                            className="alert alert-warning alert-dismissible fade show mt-2"
                            role="alert"
                          >
                            {errroMsg}
                            <button
                              type="button"
                              className="close"
                              onClick={() => setErrorMsg("")}
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                    <button
                      type="submit"
                      className="btn btn-primary w-100 py-3
                      center-textbtn mt-3 text-white text-uppercase
                      registerSubmitBtn"
                      id="submitBtn"
                    >
                      {t("confirm")}
                    </button>
                  </form>
                </div>
                <CustomModal
                  id={"upiResponseModal"}
                  title={
                    <>
                      <h5 style={{ fontWeight: "800" }}>{t('Alert')}</h5>
                      <hr className="mb-0 popupBorder"></hr>
                    </>
                  }
                  content={
                    <>
                      <p
                        className="mb-0"
                        dangerouslySetInnerHTML={{
                          __html: responseModal.message
                            ?.toLowerCase()
                            .replace(/\b\w/g, (char) => char.toUpperCase()),
                        }}
                      />
                    </>}
                  footer={
                    responseModal.status === "422" ? (
                      <button
                        type="button"
                        className="btn btn-primary w-100 py-2"
                        onClick={closeResponseModal}
                      >
                        {t('modify')}
                      </button>
                    ) : responseModal.status === "423" ? (
                      <button
                        type="button"
                        className="btn btn-primary w-100 py-2"
                        onClick={() => {
                          closeResponseModal();
                          navigate(`/${lang}/home`);
                        }}
                      >
                        {t('close')}
                      </button>
                    ) : responseModal.status !== "201" ? (
                      <button
                        type="button"
                        className="btn btn-primary w-100 py-2"
                        onClick={closeResponseModal}
                      >
                        {t('close')}
                      </button>
                    ) : null
                  }
                  show={responseModal.show}
                  onHide={closeResponseModal}
                />
                <CustomModal
                  id={"rewardUpdateModal"}
                  title={""}
                  content={
                    <>
                      <img
                        src={SuccessIcon}
                        alt="SuccessIcon"
                        className="succesIcon"
                      />
                      <img src={DelegateBottle} alt="DelegateBottle" />
                      <p className="congratulationsText">{succeMessage}</p>
                      <p className="rewardText">{t("updatesOnReward")}</p>
                    </>
                  }
                  show={rewardUpdateModal}
                  onHide={() => setRewardUpdateModal(false)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
